import React from 'react'
import { ErrorMessageProps } from '@sketch/components'
import { ActionWrapper, Message } from './InfoMessage.styles'

interface InfoMessageProps extends Pick<ErrorMessageProps, 'title' | 'icon'> {
  action?: React.ReactNode
}

const InfoMessage: React.FC<InfoMessageProps> = ({
  title,
  icon: Icon,
  children,
  action,
}) => {
  return (
    <Message
      title={title}
      icon={Icon}
      iconSize="medium"
      extra={action && <ActionWrapper>{action}</ActionWrapper>}
    >
      {children}
    </Message>
  )
}

export default InfoMessage
